// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"cb01de1e","585":"7a7e36d9"}[chunkId] + ".chunk.js";
};